import { Component, Input, OnInit } from '@angular/core';
import {Router} from "@angular/router";

export class BannerOptions {
    i18nTitleKey: string;
    imageUrl: string;
    points: { i18nTitleKey: string; i18nDescriptionKey: string }[];
    buttonOptions: { i18nTitleKey: string; url: string; callBack: Function; routerLinkOptions?: any;};
}
@Component({
    selector: 'app-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss'],
})
export class BannerComponent implements OnInit {
    @Input() bannerOptions: BannerOptions;

    constructor(
        private router: Router,
    ) {}

    ngOnInit(): void {}

    navigateTo(routerLink: any, routerLinkOptions?: any): void {
        this.router.navigate([routerLink], { queryParams: routerLinkOptions });
    }
}
